import React, { useState } from 'react';
import { MoreVertical, Calendar, Eye, Edit, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { formatToCurrency } from '../../utils/common';
import { UserAvatar, StatusBadge, ConfirmModal, ActionMenu, ActionMenuItem, ActionMenuDivider } from '../ui';

const StudentCard = ({ student, onDelete }) => {
  const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    setShowDeleteConfirm(false);
    onDelete(student._id);
  };

  const joinedDate = student.createdAt
    ? new Date(student.createdAt).toLocaleDateString('en-IN', {
        day: 'numeric', month: 'short', year: 'numeric',
        timeZone: 'Asia/Kolkata',
      })
    : '—';

  return (
    <>
    <div
      className={`student-card${student.status === 'inactive' ? ' student-card--inactive' : ''}`}
      onClick={() => navigate(`/students/${student._id}`)}
    >
      <div className="student-card-header">
        <div className="d-flex align-items-center gap-3 flex-grow-1 overflow-hidden">
          <UserAvatar name={student.name} />
          <div className="overflow-hidden">
            <div className="student-card-name">{student.name}</div>
            <div className="student-card-course">{student.course?.name || 'No Course'}</div>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2 flex-shrink-0">
          <StatusBadge status={student.status || 'active'} />
          <div onClick={(e) => e.stopPropagation()}>
            <ActionMenu trigger={<MoreVertical size={16} />}>
              <ActionMenuItem onClick={() => navigate(`/students/${student._id}`)}>
                <Eye size={14} /> View Details
              </ActionMenuItem>
              <ActionMenuItem onClick={() => navigate(`/students/edit/${student._id}`)}>
                <Edit size={14} /> Edit
              </ActionMenuItem>
              <ActionMenuDivider />
              <ActionMenuItem danger onClick={handleDelete}>
                <Trash2 size={14} /> Delete
              </ActionMenuItem>
            </ActionMenu>
          </div>
        </div>
      </div>

      <div className="student-card-body">
        <div className="student-card-row">
          <span className="student-card-label">Student ID</span>
          <span className="student-card-value">{student.mobile || '—'}</span>
        </div>
        <div className="student-card-row">
          <span className="student-card-label">Batch</span>
          <span className="student-card-value">{student.batch?.name || '—'}</span>
        </div>
        <div className="student-card-row">
          <span className="student-card-label">Fees Pending</span>
          <span className={`student-card-value ${student.pendingFees > 0 ? 'student-card-amount--pending' : 'student-card-amount--paid'}`}>
            {student.pendingFees ? formatToCurrency(student.pendingFees) : '₹0'}
          </span>
        </div>
      </div>

      <div className="student-card-footer">
        <Calendar size={14} className="me-1" />
        <span>Joined {joinedDate}</span>
      </div>
    </div>

    <ConfirmModal
      show={showDeleteConfirm}
      onHide={() => setShowDeleteConfirm(false)}
      onConfirm={confirmDelete}
      title="Delete Student"
      message={`Are you sure you want to delete ${student.name}?`}
      confirmText="Delete"
      variant="danger"
    />
    </>
  );
};

export default StudentCard;
